var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15747",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15747",
    transform: "translate(16559 -7589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15746",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15746",
    transform: "translate(-17568.061 6570.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_7",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 7",
    d: "M29.5,51.108a3.73,3.73,0,0,1-2.674-1.089L7.656,31.529c-.244-.207-.553-.5-.943-.9-.4-.414-1-1.119-1.832-2.155a29.055,29.055,0,0,1-2.238-3.217,20.327,20.327,0,0,1-1.82-4.1A15.342,15.342,0,0,1,0,16.311c0-5.026,1.51-9.046,4.486-11.95C7.443,1.468,11.525,0,16.617,0a14.23,14.23,0,0,1,4.5.76,17.539,17.539,0,0,1,4.137,2c1.17.765,2.207,1.51,3.086,2.214.369.292.75.612,1.162.979.449-.393.818-.7,1.162-.979.889-.709,1.926-1.454,3.086-2.214a17.6,17.6,0,0,1,4.143-2A14.209,14.209,0,0,1,42.383,0c5.088,0,9.17,1.467,12.135,4.359S59,11.28,59,16.311a17,17,0,0,1-1.967,7.73,26.583,26.583,0,0,1-3.178,4.768,12.647,12.647,0,0,0-2.766-2.584c2.744-3.4,4.137-6.735,4.137-9.914,0-4.027-1.1-7.053-3.348-9.252s-5.369-3.284-9.494-3.284a10.589,10.589,0,0,0-3.3.566,14.067,14.067,0,0,0-3.254,1.574C34.74,6.627,33.8,7.3,33.02,7.926a27.354,27.354,0,0,0-2.186,1.957L29.5,11.215,28.166,9.883a26.454,26.454,0,0,0-2.189-1.957c-.736-.593-1.68-1.27-2.8-2.011a14.029,14.029,0,0,0-3.254-1.574,10.58,10.58,0,0,0-3.3-.566c-4.123,0-7.23,1.074-9.5,3.284-2.25,2.2-3.342,5.226-3.342,9.252a11.578,11.578,0,0,0,.629,3.661,16.8,16.8,0,0,0,1.473,3.348,25.773,25.773,0,0,0,1.951,2.8c.941,1.172,1.383,1.669,1.59,1.88a7.153,7.153,0,0,0,.672.644l.068.054.064.063L29.479,47.331l.039,0a.005.005,0,0,0,0,0l.025-.024,3.914-3.771a12.686,12.686,0,0,0,2.531,2.809L32.178,50.02A3.743,3.743,0,0,1,29.5,51.108Z",
    transform: "translate(1016.062 1028.915)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15700",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15700",
    transform: "translate(1050.599 1055.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_676",
    "data-name": "\\u7DDA 676",
    d: "M.388,17.381A1.888,1.888,0,0,1-1.5,15.493V.388a1.888,1.888,0,1,1,3.776,0v15.1A1.888,1.888,0,0,1,.388,17.381Z",
    transform: "translate(9.052 1.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_677",
    "data-name": "\\u7DDA 677",
    d: "M1.888,18.881A1.888,1.888,0,0,1,0,16.993V1.888a1.888,1.888,0,0,1,3.776,0v15.1A1.888,1.888,0,0,1,1.888,18.881Z",
    transform: "translate(18.881 7.552) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10549",
    "data-name": "\\u9577\\u65B9\\u5F62 10549",
    width: 72,
    height: 72,
    transform: "translate(-16559 7589)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionButton);
export default __webpack_public_path__ + "static/media/reactionButton.2e7ba6f03eaeee9c268217ce56b0af8d.svg";
export { ForwardRef as ReactComponent };